
<!-------------------------------- HTML -------------------------------------->
<img id="E-{environ.ID}" class="areaEffect pinchable" draggable=false
     style=" left: {((environ.area?.col ?? environ.col) - (environ.area?.radius ?? environ.radius)) * fieldResolution}px;
             top: {((environ.area?.row ?? environ.row) - (environ.area?.radius ?? environ.radius)) * fieldResolution}px;
             width: {(environ.area?.radius ?? environ.radius) * fieldResolution * 2}px;
             height: {(environ.area?.radius ?? environ.radius) * fieldResolution * 2}px;"
     style:opacity={Math.sqrt(environ.potency) * (environ.partial ?? 1) / 3}
     src="/static/effects/{environ.classname}.gif">


<!-------------------------------- SCRIPT -------------------------------------->

<script>
    import { user, game, view } from "../client.svelte.js"
    import {fieldResolution} from "../core.js";

    let { environ } = $props()

    //ToDo: make sure that area is provided consistently (remove ?? in style above)

		// $inspect(`ENVIRON - environ`, environ)

</script>
